/**
 * CK AI content overlay: scans every <img alt="..."> on the page (any section, current
 * or future) and, when the ALT text contains the keyword configured in Theme settings >
 * CK | Image AI Content, injects the disclosure label in the image's bottom right corner.
 *
 * Runs once on load, then a MutationObserver catches images added later (AJAX cart,
 * quick view, section re-renders, infinite scroll, etc.) without a full page re-scan.
 */
(function () {
  if (window.__ckImageAiContentInit) return;
  window.__ckImageAiContentInit = true;

  var processed = typeof WeakSet === 'function' ? new WeakSet() : null;
  var processedFallback = [];

  function isProcessed(img) {
    if (processed) return processed.has(img);
    return processedFallback.indexOf(img) !== -1;
  }

  function markProcessed(img) {
    if (processed) {
      processed.add(img);
    } else {
      processedFallback.push(img);
    }
  }

  var SIZE_TOLERANCE = 6;

  // Elements with a strict/managed content model — never append into these even if
  // they're a perfect size match. Appending into <picture> in particular was observed
  // breaking this theme's `is="animate-picture"` reveal animation (assets/theme.js),
  // which expects picture's only children to be <source>/<img>.
  var UNSAFE_HOST_TAGS = { PICTURE: true, SELECT: true, TABLE: true, VIDEO: true, AUDIO: true };

  /**
   * Only treat a positioned ancestor as the image's box if it's tightly sized to it
   * (within a few px) — otherwise we'd anchor the label to something much bigger than
   * the photo (e.g. a whole grid wrapper) and it would land in the wrong corner.
   *
   * Uses offsetWidth/offsetHeight rather than getBoundingClientRect — the latter includes
   * CSS transforms, and this theme's `is="animate-picture"` reveal applies a scale
   * transform pre-load, which made the image's visual box not match its real layout box
   * and caused every candidate ancestor to fail the size check.
   */
  function tightPositionedAncestor(img, imgWidth, imgHeight) {
    var el = img.parentElement;
    while (el && el !== document.body) {
      var position = window.getComputedStyle(el).position;
      if (!UNSAFE_HOST_TAGS[el.tagName] && (position === 'relative' || position === 'absolute' || position === 'fixed' || position === 'sticky')) {
        if (Math.abs(el.offsetWidth - imgWidth) <= SIZE_TOLERANCE && Math.abs(el.offsetHeight - imgHeight) <= SIZE_TOLERANCE) {
          return el;
        }
      }
      el = el.parentElement;
    }
    return null;
  }

  function addLabel(img, config) {
    if (isProcessed(img)) return;
    markProcessed(img);

    var alt = (img.getAttribute('alt') || '').toLowerCase();
    if (alt.indexOf(config.tag) === -1) return;

    var imgWidth = img.offsetWidth;
    var imgHeight = img.offsetHeight;
    var host = tightPositionedAncestor(img, imgWidth, imgHeight);

    if (!host) {
      // No wrapper tightly matches the image box (a loosely-sized ancestor would anchor
      // the label somewhere far from the actual image — e.g. the whole article, not the
      // photo — so it's not used as a fallback). Only safe to wrap the image ourselves if
      // its direct parent doesn't have a managed content model (e.g. <picture>) — moving
      // an <img> out of one of those can break the element's own behavior (seen with this
      // theme's animate-picture reveal). If the parent is unsafe, skip labeling this image
      // rather than risk breaking it.
      if (UNSAFE_HOST_TAGS[img.parentElement.tagName]) return;

      // Wrap it ourselves, locked to its current rendered size so percentage-based image
      // CSS (width: 100%, etc.) can't recurse against the new wrapper.
      host = document.createElement('div');
      host.className = 'ck-image-ai-content-host';
      host.style.position = 'relative';
      host.style.display = 'inline-block';
      host.style.width = imgWidth + 'px';
      host.style.height = imgHeight + 'px';
      img.parentNode.insertBefore(host, img);
      host.appendChild(img);
    }

    if (host.querySelector(':scope > .ck-image-ai-content')) return;

    var label = document.createElement('span');
    label.className = 'ck-image-ai-content';
    label.style.color = config.color;
    label.textContent = config.text;
    host.appendChild(label);
  }

  function scan(root, config) {
    var images = root.querySelectorAll ? root.querySelectorAll('img[alt]') : [];
    for (var i = 0; i < images.length; i++) {
      addLabel(images[i], config);
    }
  }

  function init() {
    var settings = (window.theme && window.theme.ckImageAiContent) || {};
    var config = {
      tag: (settings.tag || '').trim().toLowerCase(),
      text: settings.text || '',
      color: settings.color || '#ffffff',
    };

    if (!config.tag || !config.text) return;

    scan(document, config);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j++) {
          var node = addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'IMG') {
            addLabel(node, config);
          } else if (node.querySelectorAll) {
            scan(node, config);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
